import { render, staticRenderFns } from "./open-account-PAMM.vue?vue&type=template&id=55758886&scoped=true"
import script from "./open-account-PAMM.vue?vue&type=script&lang=js"
export * from "./open-account-PAMM.vue?vue&type=script&lang=js"
import style0 from "./open-account-PAMM.vue?vue&type=style&index=0&id=55758886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55758886",
  null
  
)

export default component.exports